import React from 'react';
import { Clock, Sparkles, TrendingUp } from 'lucide-react';

/**
 * CP-100 — dead-hour yield engine panel. Shows the store's emptiest recurring
 * windows (from completed-visit history) and one CTA that pre-targets an
 * off-peak AI offer at the DUE_SOON retention bucket. Renders nothing while
 * loading, on error, or when there isn't enough history — the panel is a
 * nudge, never a blocker.
 */
const DeadHoursPanel = ({ summary, onFillWithOffer, generateDisabled, generating }) => {
    if (!summary || summary.sufficientData === false) {
        return null;
    }
    const windows = Array.isArray(summary.windows) ? summary.windows : [];
    if (windows.length === 0) {
        return null;
    }

    return (
        <section className="offers-deadhours-panel" aria-label="Dead hours detected">
            <div className="offers-deadhours-head">
                <div className="offers-deadhours-title-row">
                    <Clock size={15} aria-hidden="true" />
                    <h3 className="offers-deadhours-title">Dead hours detected</h3>
                </div>
                <p className="offers-deadhours-subtitle">
                    These windows run far below your normal traffic. An off-peak offer targeted at
                    customers due for their next visit is the cheapest way to fill them.
                </p>
            </div>

            <div className="offers-deadhours-windows">
                {windows.map((window) => (
                    <div className="offers-deadhours-chip" key={`${window.dayOfWeek}-${window.startHour}`}>
                        <span className="offers-deadhours-chip-label">{window.label}</span>
                        <span className="offers-deadhours-chip-ratio">
                            {Math.round((window.occupancyRatio || 0) * 100)}% of normal
                        </span>
                        {Number(window.recentVisits || 0) > 0 ? (
                            <span className="offers-deadhours-chip-fill">
                                <TrendingUp size={11} aria-hidden="true" />
                                {window.recentVisits} last week
                            </span>
                        ) : null}
                    </div>
                ))}
            </div>

            <button
                type="button"
                className="offers-deadhours-cta"
                onClick={() => onFillWithOffer(windows)}
                disabled={generateDisabled || generating}
            >
                <Sparkles size={14} aria-hidden="true" />
                {generating ? 'Generating…' : 'Fill with an off-peak offer'}
            </button>
        </section>
    );
};

export default DeadHoursPanel;
